import { createBrowserRouter } from 'react-router';
import { routes as authRoutes } from '@apps/auth/routes';
import { routes as dashboardRoutes } from '@/apps/modules/routes';
import { routes as localizationRoutes } from '@/apps/localization/routes';
import { routes as nncRoutes } from '@/apps/nnc/routes';
import { routes as accountsRoutes } from '@/apps/accounts/routes';
import { routes as settingsRoutes } from '@/apps/settings/routes';

import AppLayoutPage from './layouts/masterpage';
import NotFoundPage from '@/apps/globals/notfoundpage';

export const router = createBrowserRouter([
  {
    path: 'auth',
    children: authRoutes,
  },
  {
    path: '/',
    element: <AppLayoutPage />,
    children: [
      ...dashboardRoutes,
      ...localizationRoutes,
      ...nncRoutes,
      ...accountsRoutes,
      ...settingsRoutes,
    ],
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
]);
